import React from 'react';
import styles from './styles.css';

const Typinging = () => (
  <div className={styles.ticontainer}>
    <div className={styles.tiblock}>
      <div className={styles.tidot} />
      <div className={styles.tidot} />
      <div className={styles.tidot} />
    </div>
  </div>
);

export default Typinging;
